export default __webpack_public_path__ + "b18c432af2b89be1b5c1d70f9d676ab0.jpg";